export default {
  shouldUpdate: false,
  demographics: null,
  shouldDeepUpdate: false,
  device: "",
};
